<template>
  <div class="tla-form-group tla-form-group--margin-medium">
    <label class="tla-form-group__label tla-form-group__label--required" v-html="includeMaintenanceLabel"></label>

    <div class="tla-form-group__touch-points">
      <touchpoint v-for="(item) in options"
        :key="item.touchpointValue"
        :collectionName="'maintenanceRequired'"
        :inputId="item.touchpointValue"
        :inputValue="item.touchpointValue"
        :isSelected="item.preSelect"
        :isRadioStyle="true"
        :validationScope="validationScope"
        @maintenanceRequired="submitMaintenanceRequired($event)">
        <div class="generic-touchpoint__text" slot="touchpoint" v-html="item.touchpointName"></div>
      </touchpoint>
    </div>
    <span class="tla-form-group__message" :class="getValidationClass('maintenanceRequired', 'message')">
        Please select an option.
    </span>
  </div>
</template>

<script lang="ts">
import Vue from 'vue';
import { Component, Prop, Inject } from 'vue-property-decorator';
import { Validator } from 'vee-validate';
import { validationService } from '@/services/ValidationService';
import GenericTouchPointComponent from '../ui/GenericTouchPointComponent.vue';
import Touchpoint from '../../models/Touchpoint';

@Component({
  components: {
  touchpoint: GenericTouchPointComponent
  }
  })
export default class IncludeVehicleMaintenanceComponent extends Vue {
  @Inject('$validator') public $validator!: Validator;

  @Prop({ default: null })
  public validationScope!: string;

  @Prop({ default: 'Would you like to include maintenance? <span>*</span>' })
  public includeMaintenanceLabel!: string;

  public options: Touchpoint[] = [
    new Touchpoint('Yes', 'Yes'),
    new Touchpoint('No', 'No')
  ];

  public submitMaintenanceRequired(value: string) {
    const maintenanceRequired = value === 'Yes';
    this.$emit('selected', true);
    this.$store.dispatch('financeModule/submitMaintenanceRequired', maintenanceRequired);
  }

  public getValidationClass(fieldName: string, fieldType: string) {
    return validationService
      .getValidationClass(this.$validator, fieldName, fieldType, false, false, this.validationScope);
  }
}
</script>
